var map = {
	"./templates/404.html": 57,
	"./templates/about.html": 58,
	"./templates/articles-inner.html": 59,
	"./templates/articles.html": 60,
	"./templates/contacts.html": 61,
	"./templates/door-card.html": 62,
	"./templates/doors.html": 63,
	"./templates/examples-work.html": 64,
	"./templates/index.html": 65,
	"./templates/production.html": 66,
	"./templates/products.html": 67,
	"./templates/services.html": 68,
	"./templates/template.html": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;